<div class="pp-wrapper">
  <div class="pp-input-with-icon">
    <input
      type="text"
      class="pp-input field-input"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [ngModel]="searchText"
      (ngModelChange)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      autocomplete="off"
    />
    <button type="button" class="pp-icon-btn input-icon-btn" tabindex="-1">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <circle cx="10" cy="10" r="7" />
        <line x1="22" y1="22" x2="15.5" y2="15.5" />
      </svg>
    </button>
  </div>

  @if (dropdownOpen && peopleData.length > 0) {
    <ul class="pp-suggestions">
      @for (person of peopleData; track person.InternetMail) {
        <li class="pp-suggestion-item" (mousedown)="selectPerson(person)">
          {{ person.InternetMail }}
        </li>
      }
    </ul>
  }
</div>
